import { render, staticRenderFns } from "./CmgMessageBar.vue?vue&type=template&id=b3a1fc34&scoped=true&lang=pug"
import script from "./cmg-message-bar.ts?vue&type=script&lang=ts&external"
export * from "./cmg-message-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMessageBar.vue?vue&type=style&index=0&id=b3a1fc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a1fc34",
  null
  
)

export default component.exports